/**
 * Airoso Eva - Cart Drawer Upsell / 1-Click Quick Add
 * Handles immediate addition of recommended jewellery products with zero page refresh required.
 */
(function() {
  'use strict';

  if (window.CartDrawerUpsellInitialized) return;
  window.CartDrawerUpsellInitialized = true;

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-quick-add-btn]');
    if (!btn) return;

    if (btn.disabled || btn.getAttribute('data-loading') === 'true') {
      return;
    }

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const itemCard = btn.closest('[data-upsell-item]');
    const originalText = btn.textContent;

    btn.disabled = true;
    btn.setAttribute('data-loading', 'true');
    btn.textContent = 'Adding...';

    const rootUrl = window.Shopify?.routes?.root || '/';

    // Collect all cart items section IDs so Shopify re-renders the updated drawer
    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function(c) {
      if (c.dataset.sectionId && !sectionIds.includes(c.dataset.sectionId)) {
        sectionIds.push(c.dataset.sectionId);
      }
    });
    if (!sectionIds.includes('header_section')) {
      sectionIds.push('header_section');
    }

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionIds.join(',')
      })
    })
    .then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok) throw data;
        return data;
      });
    })
    .then(function(item) {
      btn.textContent = 'Added! ✓';
      btn.classList.add('is-added');

      // If user is on full cart page (/cart), smoothly refresh
      if (window.location.pathname.includes('/cart')) {
        setTimeout(function() {
          window.location.reload();
        }, 600);
        return;
      }

      // 1. Dispatch theme cart:update event with returned sections to morph the drawer
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: item,
          sourceId: variantId,
          data: {
            sections: item.sections,
            source: 'quick-add'
          }
        }
      }));

      // 2. Smoothly scroll cart items list to top so newly added product is immediately visible
      setTimeout(function() {
        const itemsContainer = document.querySelector('.cart-drawer__items');
        if (itemsContainer) {
          itemsContainer.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);

      // 3. Update cart count bubbles & free shipping progress bar
      fetch(rootUrl + 'cart.js', { cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[ref="cartItemCount"], .cart-bubble span, .header-actions__cart-icon .cart-bubble span').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          const cartIcon = document.querySelector('.header-actions__cart-icon');
          if (cartIcon) {
            if (cart.item_count > 0) {
              cartIcon.classList.add('header-actions__cart-icon--has-cart');
            } else {
              cartIcon.classList.remove('header-actions__cart-icon--has-cart');
            }
          }
          if (typeof window.updateFreeShippingUI === 'function') {
            window.updateFreeShippingUI(cart.total_price);
          }
        })
        .catch(function(e) {
          console.warn('Cart count update error:', e);
        });
    })
    .catch(function(err) {
      console.warn('Quick add info:', err);
      btn.removeAttribute('data-loading');
      const msg = (err && (err.description || err.message)) ? (err.description || err.message) : '';

      if (msg.includes('already') || msg.includes('All') || msg.includes('items are in your cart')) {
        btn.textContent = 'In Cart ✓';
        btn.classList.add('is-added');
        btn.disabled = true;
        if (itemCard) {
          setTimeout(function() {
            itemCard.style.opacity = '0.5';
          }, 500);
        }
      } else {
        btn.textContent = 'Unavailable';
        btn.disabled = true;
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2000);
      }
    });
  });
})();
